import { useUser } from "@/context/useUser";
import { getTenantId } from "@/lib/storeManager";
import ForgotPasswordSchema from "@/schemas/ForgotPasswordSchema";
import navigationRoutes from "@/utils/navigationRoutes";
import { FormItem, Input, Password, Submit } from "@formily/antd-v5";
import { createForm } from "@formily/core";
import { FormProvider, createSchemaField } from "@formily/react";
import { Card } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const form = createForm({});

const SchemaField = createSchemaField({
  components: { FormItem, Input, Password },
});

const ForgotPasswordForm: React.FC = () => {
  const { forgotPassword, isAuthenticated } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const tenantId = getTenantId() ?? "";

  const handleSubmit = async (values: { email: string }) => {
    setLoading(true);
    const response = await forgotPassword(values.email);
    if (response) {
      navigate(navigationRoutes.SCHEMAS);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate(navigationRoutes.SCHEMAS);
    }
  }, [isAuthenticated, tenantId, navigate]);

  return (
    <Card
      title="Forgot Password"
      className="w-full max-w-md rounded-xl shadow-xl"
    >
      <FormProvider form={form}>
        <SchemaField schema={ForgotPasswordSchema} />
        <Submit
          onSubmit={handleSubmit}
          disabled={loading}
          className="w-full rounded-md px-4 py-2 text-white"
        >
          {loading ? "Sending Reset Email…" : "Send Reset Email"}
        </Submit>
      </FormProvider>
    </Card>
  );
};

export default ForgotPasswordForm;
